export default function(images){
    
    let groupedImages = {
        avatar: {},
        backgroundImage: {},
        headerImage: {},
        galleryImages: []
    };
    
    images.forEach(image => {
        if(image.type !== 'galleryImage')
            groupedImages[image.type] = image;
        else 
            groupedImages.galleryImages.push(image);
    });

    return groupedImages;

}